var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOctagone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.851,
    height: 13.244,
    viewBox: "0 0 14.851 13.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_60",
    "data-name": "Caminho 60",
    d: "M107.732.23l5.053,2.909a1.458,1.458,0,0,1,.766,1.378v5.818a1.458,1.458,0,0,1-.766,1.378l-5.053,2.909a1.52,1.52,0,0,1-1.608,0l-5.053-2.909a1.608,1.608,0,0,1-.766-1.378V4.516a1.608,1.608,0,0,1,.766-1.378L106.124.23a1.52,1.52,0,0,1,1.608,0Z",
    transform: "translate(14.851 -100.306) rotate(90)",
    fill: "#81d742",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctagone);
export default __webpack_public_path__ + "static/media/Octagone.1282febb94903515bc5fb6c8acdc05f6.svg";
export { ForwardRef as ReactComponent };